import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import FailedTransactionsTable from '../components/FailedTransactionsTable';
interface FailedTransactionsProps {
  onLogout: () => void;
}
const FailedTransactions: React.FC<FailedTransactionsProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-4068">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Failed Transactions" data-id="element-4069" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="failed-transactions" data-id="element-4070" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-4071">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-4072">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-4073">
            <Icon icon="lucide:alert-circle" width={28} height={28} color="#EF4444" data-id="element-4074" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-4075">
              Failed Transactions
            </Typography>
          </Box>
          <FailedTransactionsTable data-id="element-4076" />
        </Box>
      </Box>
    </Box>;
};
export default FailedTransactions;